export const MESSAGE = {
  ENG: {
    DELIVERY_IMPORT: 'Upload delivery details', 
    LOADING_IMPORT: 'Upload loading details',
    FREIGHT_IMPORT: 'Upload freight details',
    MASTER_IMPORT: 'Upload master details',
    START_IMPORT: 'START IMPORT',
    APP_TITLE: 'Data uploader | Jules AI',
    LOGISTIC_FORWARDER: 'logistic forwarder',
    LOADING_UNIT: 'Volume unit & loading type',
    DELIVERY_UNIT: 'Volume unit & delivery type',
    GO: 'Go',
    POPUP_VALIDATION: 'Required',
    POPUP_LOADING_VALIDATION: 'All fields are mandatory',
    LOADING_TYPE: 'Select loading type',
    DELIVERY_TYPE: 'Select delivery type',
    VALIDITY_MONTH: 'Select validity month',
    LOGISTIC_MATERIAL: 'Select logistic material',
    QUALITY_GROUP: 'Select quality group',
    INCO_TERMS: 'Select incoterm',
    LOGISTIC_FORWARDER_SHIPPING_LINE: 'Select value',
    FREIGHT_POPUP: 'Select below details',
    INVALID_CREDENTIALS: 'Your email and/or password are incorrects',
    VALID_CREDENTIALS: 'Login successfull',
    SAMPLE_TEMPLATE: 'Download template',
    SUPPORT_HELP: 'Support',
    MASTER_IMPORT_TYPE: 'Select import type',
    STANDARDLIST: 'Standard List',
    CUSTOMLIST: 'Custom List',
    SELECT: 'Select',
    CONTRACT_IMPORT: 'Renew contract details',
    CONTRACT: 'Renew contract',
    CONFIRMATION_TEXT:'Are you sure you want to renew the records?',
    CONFIRMATION_YES: 'Yes',
    CONFIRMATION_NO: 'No',
    RENEW: 'Renew',
    RENEWING_TEXT: 'Renewing the records',
    FROM: 'from',
    TO: 'to',

  },
};